let claimBtn = document.querySelector(
  ".wolt-drive-user-order-delivery.subscriptions-button"
) as HTMLButtonElement;
let ordersPopup = document.querySelector(".orders-popup") as HTMLElement;
let subCancelButton = document.getElementById(
  "subButtonCancel"
) as HTMLLinkElement;
let subCancelConfirmButton = document.getElementById(
  "subCancelConfirmButton"
) as HTMLButtonElement;
let subCancelDenyButton = document.getElementById(
  "subCancelDenyButton"
) as HTMLButtonElement;
let subCancelModal = document.getElementById(
  "subCancelModal"
) as HTMLElement;

if (subCancelButton && subCancelConfirmButton && subCancelModal && subCancelDenyButton) {
  subCancelButton.addEventListener("click", (e) => {
    e.preventDefault();
    subCancelModal.style.display = "flex";
  });
  subCancelConfirmButton.addEventListener("click", (e) => {
    window.location.href = subCancelButton.href;
  });
  subCancelDenyButton.addEventListener("click", (e) => {
    subCancelModal.style.display = "none";
  });
}

if (claimBtn && ordersPopup) {
  let htmlObserverClaim = new MutationObserver(observerCallback);
  let popupCloseBtn = ordersPopup.querySelector(".orders-popup__close");

  if (popupCloseBtn) {
    popupCloseBtn.addEventListener("click", (e) => {
      ordersPopup.style.display = "none";
    });
  }

  htmlObserverClaim.observe(
    document.querySelector(".order-single__right") as HTMLElement,
    {
      childList: true,
      subtree: true,
    }
  );

  function observerCallback() {
    claimBtn.disabled = false;
    claimBtn.classList.remove("loading");

    let woltNotice = document.querySelector(".wolt-notice");

    if (woltNotice?.textContent != "Delivery has been scheduled") {
      let popupTitle = ordersPopup.querySelector(".orders-popup__title");
      let popupText = ordersPopup.querySelector(".orders-popup__message");

      if (popupTitle && popupText) {
        popupTitle.textContent = "Delivery not confirmed!";
        popupText.textContent =
          "Delivery could not be confirmed. Please contact site administrator.";
      }

      ordersPopup.style.display = "flex";
    } else if (woltNotice?.textContent == "Delivery has been scheduled") {
      sendUserClaimedEvent();
    }
  }

  claimBtn.addEventListener("click", (e) => {
    claimBtn.disabled = true;
    claimBtn.classList.add("loading");
  });
}

function sendUserClaimedEvent() {
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("id")) {
    let orderId = urlParams.get("id");

    const ajaxData = (window as any).njamito_ajax;

    if ((window as any).njamito_ajax && orderId) {
      let data = new FormData();

      data.append("action", "njamito_user_claimed_event");
      data.append("orderId", orderId);
      data.append("nonce", ajaxData.nonce);

      fetch(ajaxData.ajax_url, {
        method: "POST",
        body: data,
      })
        .then((response) => {
          return response.json();
        })
        .then((jsonResponse) => {
          if (!jsonResponse.success) {
          }

          if (jsonResponse.success) {
          }
        });
    }
  }
}
